export default function ArrowNE() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.26683 11.9999L3.3335 11.0666L9.7335 4.66659H4.00016V3.33325H12.0002V11.3333H10.6668V5.59992L4.26683 11.9999Z"
        fill="white"
      />
    </svg>
  );
}
